const deepClone = data => {
    return JSON.parse(JSON.stringify(data));
};

const getTotalCount = cart => {
    return cart.lineItems.reduce((total, val) => parseInt(total) + parseInt(val.qty), 0);
};

const updateCount = cart => {
    let cartCounts = Array.from(document.querySelectorAll(".cart-count"));

    cartCounts.forEach(cartCount => {
        if (cart && cartCount) {
            let count = getTotalCount(cart);
            cartCount.innerHTML = count > 0 ? count : "";
        }
    });
};

export { deepClone, updateCount };
